var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPerson = function SvgPerson(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37,
    height: 37,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.25,
    cy: 12.25,
    r: 9.5,
    stroke: "#262929",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#262929",
    strokeWidth: 3,
    d: "M34.25 36.25a9 9 0 0 0-9-9h-14a9 9 0 0 0-9 9"
  })));
};
export default SvgPerson;